import { Trophy } from 'lucide-react';
import { cn } from '@/lib/cn';

interface WinnerBadgeProps {
  isWinner: boolean;
  className?: string;
}

export function WinnerBadge({ isWinner, className }: WinnerBadgeProps) {
  if (!isWinner) return null;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-amber-500/15 px-2 py-0.5 text-[11px] font-medium text-amber-600 dark:text-amber-400',
        className,
      )}
    >
      <Trophy className="h-3 w-3" />
      Top 25%
    </span>
  );
}
